import React from "react";
import { Link } from "react-router-dom";

export const IHCITravelGrant = () => {
  return (
    <>
      <div className="visa-big-box container">
        <h5>
          The organizing committee of the Intelligent Human-Computer Interaction
          (IHCI) Society is pleased to announce the availability of travel
          grants to support participants in attending the conference. These
          grants are aimed at assisting individuals who would otherwise be
          unable to attend due to financial constraints. The travel grant will
          cover a portion of the expenses related to travel, accommodation, and
          registration fees.
        </h5>
        <h4>Eligibility Criteria:</h4>
        <h5 className="information">
          The applicant must be an active researcher, practitioner, or student
          working in the field of Human-Computer Interaction (HCI).
        </h5>
        <ul>
          <li>
            The applicant should have an accepted paper, poster, workshop, or
            demonstration at the IHCI Conference.
          </li>
          <li>
            Priority will be given to applicants from developing countries and
            underrepresented communities in HCI.
          </li>
          <li>
            Applicants must demonstrate financial need and provide a clear
            justification for receiving the travel grant.
          </li>
          <li>
            Previous recipients of IHCI Conference travel grants are not
            eligible to apply.
          </li>
        </ul>

        <h4>Application Process:</h4>
        <h5 className="information">
          Interested applicants must submit a complete travel grant application
          by the specified deadline. The application should include the
          following information:
        </h5>
        <ul>
          <li>Full name, contact details, and affiliation of the applicant.</li>
          <li>
            Title and abstract of the accepted paper, poster, workshop, or
            demonstration.
          </li>
          <li>A statement of financial need and the amount requested.</li>
          <li>
            An explanation of how attending the IHCI Conference will benefit the
            applicant's research or professional development.
          </li>
          <li>
            Any additional supporting documents, such as recommendation letters
            or proof of financial constraints.
          </li>
        </ul>
        <h5 className="information">
          All applications must be submitted electronically to the designated
          email address:{" "}
          <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>
          or through the online submission system.
        </h5>

        <h4>Selection Process:</h4>
        <h5 className="information">
          The IHCI Conference travel grant committee will review all
          applications and make the final selection.
        </h5>
        <ul>
          <li>
            The committee will consider the applicant's eligibility, financial
            need, contribution to the conference, and potential impact on the
            HCI community.
          </li>
          <li>
            The decisions of the committee will be final and not subject to
            appeal.
          </li>
          <li>
            Selected applicants will be notified via email within a specified
            time frame.
          </li>
        </ul>

        <h4>Travel Grant Conditions:</h4>
        <ul>
          <li>
            The travel grant is intended to partially cover the costs associated
            with attending the IHCI Conference, including travel, accommodation,
            and registration fees.
          </li>
          <li>
            The grant amount will be determined by the committee based on
            available funds and the financial needs of the selected applicants.
          </li>
          <li>
            The grant will be awarded directly to the selected applicants and
            should be used exclusively for conference-related expenses.
          </li>
          <li>
            Recipients of the travel grant will be required to provide proof of
            attendance and submit a brief report on their conference experience
            within a specified period after the event.
          </li>
        </ul>

        <h4>Important Dates:</h4>
        <ul>
          <li>Travel grant application deadline: October 5, 2023</li>
          <li>Notification of travel grant acceptance: October 15, 2023</li>
          <li>IHCI Conference dates: November 8 - 10, 2023</li>
        </ul>

        <h5>
          <b>Note:</b> The information provided in this call for travel grant is
          subject to change. Applicants are advised to refer to the official
          IHCI Conference website, for the most up-to-date information and
          application guidelines.
        </h5>
        <h5>For further inquiries or clarifications regarding the travel grant,
          please contact:{" "}
          <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link></h5>
      </div>
      <hr className="hr-style" />
    </>
  );
};
